module.exports = __webpack_public_path__ + "static/media/Dewitt Durham.91410e68.png";